<template>
  <el-dialog
    class="dialog-form"
    title="类型设置"
    :visible="isShow"
    width='780px'
    :append-to-body="true"
    :destroy-on-close="true"
    :close-on-click-modal='false'
    @close="onClose">
    <el-form ref="infoForm" :model="formData" :rules="rules">
      <el-table ref="table" class="global-table" v-loading="loading" :data="tableData">
        <el-table-column label="类型名称" prop="typeName">
          <template v-slot="{ row, $index }">
            <template v-if="$index === editIndex">
              <el-form-item prop="facilityTypeName">
                <el-input v-model.trim="formData.facilityTypeName" placeholder="请输入类型名称" clearable maxlength="10" show-word-limit></el-input>
              </el-form-item>
            </template>
            <template v-else>
              {{row.facilityTypeName}}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="关联巡查要素(选填)" show-overflow-tooltip>
          <template v-slot="{ row, $index }">
            <template v-if="$index === editIndex">
              <el-form-item prop="elementId">
                <el-select v-model="formData.elementId" placeholder="请选择关联对象" filterable clearable>
                  <el-option v-for="item in elementList" :key="item.elementId" :value="item.elementId" :label="item.elementName"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              {{row.elementName || ''}}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="类型图标" width="120">
          <template v-slot="{ row, $index }">
            <template v-if="$index === editIndex">
              <el-form-item prop="icon">
                <el-dropdown @command="handleCommandItem">
                  <div class="dropdown-area">
                    <img v-if="formData.icon" :src="iconPathPrefix + formData.icon + '_1.png'" width="30px" height="30px">
                    <span v-else>下拉选择</span>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="index" v-for="(item, index) in iconList" :key="index">
                      <img :src="iconPathPrefix + item.icon + '_1.png'" width="30px" height="30px">
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </template>
            <template v-else>
              <img :src="iconPathPrefix + row.icon + '_1.png'" width="30px" height="30px">
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px" fixed="right">
          <template v-slot="{ row, $index }">
            <template v-if="$index === editIndex">
              <el-form-item>
                <el-button type="text" @click="onSave">保存</el-button>
                <el-button type="text" @click="onCancel">取消</el-button>
              </el-form-item>
            </template>
            <template v-else>
              <el-button type="text" @click="onEdit($index)">编辑</el-button>
              <el-button type="text" @click="onDelete(row.facilityTypeId)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-button type="text" @click="onAdd">新增类型</el-button>
  </el-dialog>
</template>

<script>
import { iconUrl } from '@/utils/config'

export default {
  name: 'PointTypeSet',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editIndex: -1,
      loading: false,
      tableData: [],
      iconList: [],
      elementList: [],
      formData: {
        facilityTypeName: '',
        elementId: '',
        icon: ''
      },

      rules: {
        facilityTypeName: [
          { required: true, message: '请输入类型名称', trigger: ['blur', 'change'] }
        ],
        icon: [
          { required: true, message: '请选择类型图标', trigger: ['blur', 'change'] }
        ]
      }

    }
  },

  computed: {
    iconPathPrefix () {
      return iconUrl
    }
  },

  created () {
    this.loadElementList()
    this.loadIconList()
    this.loadData()
  },
  methods: {

    // 巡查要素
    loadElementList () {
      this.$axios.get(this.$apis.patrol.selectElementByList).then(res => {
        this.elementList = res.list || []
      })
    },

    loadIconList () {
      this.$axios.get(this.$apis.patrol.selectIconByList).then(res => {
        this.iconList = res || []
      })
    },

    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.patrol.selectFacilityTypeByList).then(res => {
        this.tableData = res.list
        // 滚动到表格顶部
        this.$nextTick(() => {
          this.$refs.table.bodyWrapper.scrollTop = 0
        })
      }).finally(() => {
        this.loading = false
      })
    },

    // 判断表格状态
    validateState () {
      if (this.editIndex >= 0) {
        this.$message.warning('请先保存')
        return false
      }
      return true
    },

    onAdd () {
      if (this.validateState()) {
        this.editIndex = this.tableData.length
        this.formData = {
          facilityTypeName: '',
          icon: '',
          elementId: ''
        }
        this.tableData.push({ ...this.formData })
        // 滚动到表格最底部
        this.$nextTick(() => {
          const table = this.$refs.table
          table.bodyWrapper.scrollTop = table.bodyWrapper.scrollHeight
        })
      }
    },

    async onEdit (index) {
      if (this.validateState()) {
        this.formData = {
          ...this.tableData[index]
        }
        this.editIndex = index
      }
    },

    onCancel () {
      this.editIndex = -1
      this.loadData()
    },

    onSave () {
      this.$refs.infoForm.validate().then(() => {
        const url = this.formData.facilityTypeId ? this.$apis.patrol.updateFacilityType : this.$apis.patrol.insertFacilityType
        this.$axios.post(url, this.formData).then(res => {
          this.onCancel()
        })
      })
    },

    handleCommandItem (index) {
      this.formData.icon = this.iconList[index].icon
    },

    onDelete (facilityTypeId) {
      if (this.validateState()) {
        this.$confirm('确定删除此类型,是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$apis.patrol.deleteFacilityType, {
            facilityTypeId
          }).then(() => {
            this.loadData()
          })
        })
      }
    },

    onClose () {
      this.$emit('update:isShow', false)
    }
  }

}
</script>

<style scoped lang="scss">
  .dialog-form {
    ::v-deep {
      .el-dialog__header {
        border-bottom: 1px solid #dddddd;
        height: 51px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px  0  20px;
        .el-dialog__title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
        }
      }
      .el-dialog__body {
        padding: 20px 20px 20px 20px;
        .el-form-item--small.el-form-item{
          margin-bottom: 30px;
        }
      }
    }
    .el-dropdown {
      width: 100%;
      .dropdown-area {
        width: 100%;
        max-height: 40px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border: 1px solid #dcdfe6;
        cursor: pointer;
      }
    }
  }
  /*.el-form{*/
  /*  .el-form-item {*/
  /*    &:nth-of-type(2){*/
  /*      .el-select {*/
  /*        width: 40%;*/
  /*        &:nth-of-type(2){*/
  /*          width: 50%;*/
  /*        }*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/
  /*.form-inline {*/
  /*  margin-top: 20px;*/
  /*  padding: 0 10px;*/
  /*  display: flex;*/
  /*  justify-content: space-between;*/
  /*  .form-item {*/
  /*    width: 26%;*/
  /*    &:nth-child(2) {*/
  /*      width: 48%;*/
  /*      text-align: center;*/
  /*    }*/
  /*    &:nth-child(4) {*/
  /*      width: 12%;*/
  /*    }*/
  /*  }*/
  /*}*/
  /*::v-deep {*/
  /*  .el-form-item__content {*/
  /*    width: 100%;*/
  /*  }*/
  /*  .el-dropdown {*/
  /*    display: flex;*/
  /*    width: 100%;*/
  /*  }*/
  /*  .el-dropdown-selfdefine {*/
  /*    display: flex;*/
  /*    justify-content: space-around;*/
  /*    align-items: center;*/
  /*    width: 100%;*/
  /*    border: 1px solid #dcdfe6;*/
  /*    background-color: #FFF;*/
  /*  }*/
  /*  .el-table__row {*/
  /*     td {*/
  /*       &:nth-of-type(2) {*/
  /*         .el-select {*/
  /*           width: 40%;*/

  /*           &:nth-of-type(2) {*/
  /*             width: 50%;*/
  /*           }*/
  /*         }*/
  /*       }*/
  /*     }*/
  /*   }*/
  /*  .el-table__body-wrapper {*/
  /*    max-height: calc(100vh - 500px);*/
  /*    overflow-y: auto;*/
  /*  }*/
  /*}*/
</style>
